import axios from 'axios'
export class Document {
    constructor(type, token){
        this._serie = ''
        this._numero = ''
        this._receptor = ''
        this._token = token
        this._type = type 
    }
    // Metodos Getter and Setter
    get serie(){
        return this._serie
    }
    set serie(val){
        this._serie = val
    }
    get numero(){
        return this._numero
    }
    set numero(val){
        this._numero = val
    }
    get receptor(){
        return this._receptor
    }
    set receptor(val){
        this._receptor = val
    }
    totalIgv(){
        let val = 0.00
      let valGratuita = 0.00
        this.items.forEach(function(element) {
        (element.codigoTributo=='9996' && element.tipoPrecioVentaUnitario=='02') ? valGratuita += parseFloat(element.montoAfectacionIgv): val += parseFloat(element.montoAfectacionIgv)
        })
        return totaligv
    }
    // Sumatoria de montos para items de tipo gravado
    totalGravado(){
        let totalgravado = 0.00
        return totalgravado
    }
    // Sumatoria de montos para items de tipo exonerados
    totalExonerado(){
        let totalexonerado = 0.00
        return totalexonerado
    }
    // Sumatoria de montos para items de tipo infecta
    totalInafecto(){
        let totalinafecto = 0.00
        return totalinafecto
    }
    // Sumatoria de montos para items de tipo gratuita
    totalGratuito(){
        let totalgratuito = 0.00
        return totalgratuito
    }
    // Sumatoria de items de exportacion
    totalExportacion(){
        let totalexportacion = 0.00
        return totalexportacion
    }
    // Sumatoria de anticipos
    totalAnticipos(){
        let totalanticipos = 0.00
        return totalanticipos
    }
    // Sumatoria de descuentos por item
    totalDescuentos(){
        let totaldescuentos = 0.00
        return totaldescuentos
    }
    // Sumatoria de otros cargos
    totalOtrosCargos(){
        let totalotroscargos = 0.00
        return totalotroscargos
    }
    // Sumatoria venta total
    totalVenta(){
        let totalventa = 0.00
        return totalventa
    }
    toJson(){
        let json = {

        }
        return json
    }
}